(function(w, d) {
  var config = {
    'thepulse.allstroreshop.com': {shop: 'b3s0az-15', key: 'pulse'},
    'official.allstroreshop.com': {shop: '0misi6-cs', key: 'official'},
    'thebravyn.allstroreshop.com': {shop: '1wuxdf-k6', key: 'bravyn'}
  }[w.location && w.location.hostname];
  if (!config || w.location.protocol !== 'https:' || !w.isSecureContext || !w.Shopify || w.Shopify.shop !== config.shop + '.myshopify.com' || w.__dropPrivacyPublisherV1) return;
  var jar = w.cookieStore, request = 0;
  var name = '__Secure-drop_privacy_' + config.key + '_v1';
  function emit(state, ready) {
    try { d.dispatchEvent(new CustomEvent('drop:privacy-state', {detail: {role: 'publisher', store: config.shop, marketing: state.m, analytics: state.a, preferences: state.p, ready: ready}})); } catch (error) {}
  }
  function read() {
    var state = {m: false, a: false, p: false};
    try {
      var api = w.Shopify.customerPrivacy, choice = api && api.currentVisitorConsent();
      if (choice) {
        state.m = choice.marketing !== 'no' && api.marketingAllowed() === true && api.saleOfDataAllowed() === true && !(w.navigator && w.navigator.globalPrivacyControl === true);
        state.a = choice.analytics !== 'no' && api.analyticsProcessingAllowed() === true;
        state.p = choice.preferences !== 'no' && api.preferencesProcessingAllowed() === true;
      }
    } catch (error) { state = {m: false, a: false, p: false}; }
    return state;
  }
  function refresh() {
    var state = read(), generation = ++request;
    if (!jar || typeof jar.get !== 'function') { emit({m: false, a: false, p: false}, false); return Promise.resolve(false); }
    try {
      var now = Date.now();
      var value = {v: 1, s: config.shop, m: state.m, a: state.a, p: state.p, i: now, e: now + 1800000};
      var encoded = encodeURIComponent(JSON.stringify(value));
      d.cookie = name + '=' + encoded + '; Domain=allstroreshop.com; Path=/; Secure; SameSite=Lax; Max-Age=1800';
      return Promise.resolve().then(function() { return jar.get(name); }).then(function(cookie) {
        if (generation !== request) return false;
        var ready = !!cookie && cookie.value === encoded;
        emit(ready ? state : {m: false, a: false, p: false}, ready);
        return ready;
      }).catch(function() { if (generation === request) emit({m: false, a: false, p: false}, false); return false; });
    } catch (error) { emit({m: false, a: false, p: false}, false); return Promise.resolve(false); }
  }
  w.__dropPrivacyPublisherV1 = {refresh: refresh};
  d.addEventListener('visitorConsentCollected', refresh);
  d.addEventListener('DOMContentLoaded', refresh);
  d.addEventListener('visibilitychange', refresh);
  refresh();
  if (!w.Shopify.customerPrivacy && typeof w.Shopify.loadFeatures === 'function') {
    try { w.Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.2'}], function() { refresh(); }); } catch (error) { refresh(); }
  }
  if (typeof w.setInterval === 'function') w.setInterval(refresh, 60000);
})(window, document);